import Homepage from './homepage/HomePage';

export { getServerSideProps } from './homepage/serverSideProps';

export default Homepage;
